import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'accounting',
  size: 'full',
  children: {
    overview: {
      path: 'overview',
    },
    ledgerAccounts: {
      path: 'ledger-accounts',
    },
    import: {
      path: 'import',
    },
    generalLedger: {
      path: 'general-ledger',
    },
    draftEntries: {
      path: 'draft-entries',
    },
    ledgerAccountId: {
      path: ':ledgerAccountId',
    },
  },
} as const satisfies Location
